export default "__VITE_ASSET__0a9029fa__"